import { ChatMessageUserAttachment } from "./chat-message-user-attachment";
import { ChatMessageUserAudio } from "./chat-message-user-audio";
import { useConversationConfiguration } from "../../ai/ask/chat/conversation-type-provider";
import { ChatUserMediaRecord } from "../../types";
import { MimeMainType } from "~/types/mime-main-type";
import { cn } from "~/util/cn";
import "../chat.css";

export const ChatMessageUser: React.FC<{
  text?: string;
  media?: ChatUserMediaRecord[];
}> = ({ text = " ", media }) => {
  const { user } = useConversationConfiguration();

  return (
    <div
      className={cn(
        "max-w-[min(360px,_80vw)] whitespace-pre-line px-5 py-4 animate-slideIn",
        "triangle rounded-2xl rounded-br-none",
        user.chatBubble.className,
      )}
    >
      <p className="notranslate">{text.trim()}</p>

      {media?.map((item) => {
        switch (item.mainType) {
          case MimeMainType.AUDIO:
            return (
              <ChatMessageUserAudio
                key={item.path}
                base64OrSignedURL={item.path}
                transcription={item.extractedText || ""}
                className="max-w-xs"
              />
            );
          case MimeMainType.IMAGE:
            return (
              <ChatMessageUserAttachment key={item.path} base64={item.path} />
            );
        }
      })}
    </div>
  );
};
